import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importando o Bootstrap
import './Navbar.css'; // Estilos adicionais, se necessário

const Navbar = () => {
  return (
    <div className="navbar justify-content-center" style={{backgroundColor: "#1E1C1C"}}>

      
      {/* Div para o conteúdo com logomarca e texto lado a lado */}
      <div className="container d-flex flex-column flex-sm-row justify-content-center align-items-center py-2">
        {/* Logomarca */}
        <div className="mx-5">
          <img src="Logotipo 1-fundopreto2.png" alt="IMO Investimentos" style={{ height: '120px' }} />
        </div>

        {/* Texto ao lado da logomarca */}
        {/* <div className="navbar-text text-white col-8 col-sm-3 special-font d-flex align-items-center" style={{fontSize: "22px"}}>
          <p className="m-0">Invista com Segurança e <span className="highlight">Alta Rentabilidade</span> no mercado imobiliário europeu</p>
        </div> */}
      </div>
    </div>
  );
};

export default Navbar;



